import { conversationServiceV2, clientsCentralSearchServiceV2, conversationService } from 'config/api';
import { phoneNumberFormatter } from 'utils';
import actionTypes from './actionTypes';

export const getConversationsV2 =
  (associateId, pagination = {}, filter = {}) =>
  async (dispatch) => {
    dispatch({ type: actionTypes.GET_CONVERSATIONS_V2_LOADING });

    try {
      const { data } = await conversationServiceV2.post('/inbox', {
        associateId,
        pagination,
        filter,
      });
      const payload = {
        items: data?.Items,
        count: data?.Count,
      };
      dispatch({ type: actionTypes.GET_CONVERSATIONS_V2_SUCCESS, payload });
    } catch (err) {
      dispatch({ type: actionTypes.GET_CONVERSATIONS_V2_ERROR, payload: err });
    }
  };

export const getDleChatCount = (associateId) => async (dispatch) => {
  try {
    const { data } = await conversationServiceV2.post('/inbox/count', {
      associateId,
      filter: { messageType: ['dle_chat'] },
    });
    dispatch({ type: actionTypes.GET_CONVERSATIONS_V2_DLE_SUCCESS, payload: data?.Count });
  } catch (err) {
    //eslint-disable-next-line no-console
    console.error(err);
  }
};

export const clearConversations = () => ({
  type: actionTypes.CLEAR_CONVERSATIONS,
});

export const updateConversation = (conversation) => ({
  type: actionTypes.UPDATE_CONVERSATION,
  payload: conversation,
});

export const getRelatedProfiles = (phoneNumberToSearch) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_RELATED_PROFILES });
  try {
    const params = {
      q: phoneNumberFormatter(phoneNumberToSearch, 'outBoundVoice'),
      includeClientList: true,
      field: 'phone',
    };
    const clientSearchMatches = await clientsCentralSearchServiceV2.get('/customers', { params });

    const relatedProfiles = clientSearchMatches.data.data.customers;
    const count = relatedProfiles.length;
    const profileId = count ? clientSearchMatches.data.data.customers[0].profileId : null;

    const payload = { profileId, relatedProfiles };

    dispatch({ type: actionTypes.GET_RELATED_PROFILES_SUCCESS, payload });
    return payload;
  } catch (err) {
    dispatch({ type: actionTypes.GET_RELATED_PROFILES_ERROR, payload: err });
  }
};

export const clearRelatedProfiles = () => ({
  type: actionTypes.CLEAR_RELATED_PROFILES,
});

export const updateCallLog = (conversation) => ({
  type: actionTypes.UPDATE_CALL_LOG,
  payload: conversation,
});

export const updateCallLogV2 = (conversation) => async (dispatch) => {
  try {
    const { externalAddress } = conversation;
    const params = {
      q: phoneNumberFormatter(externalAddress, 'outBoundVoice'),
      includeClientList: true,
      field: 'phone',
    };

    const clientSearchMatches = await clientsCentralSearchServiceV2.get('/customers', { params });
    const relatedProfiles = clientSearchMatches.data.data.customers;

    let profile = relatedProfiles[0] || null;
    if (relatedProfiles?.length > 1) {
      profile = relatedProfiles.find((customer) => customer.primaryPhone);
    }

    const profileName = profile ? `${profile.firstName} ${profile.lastName}` : '';

    const payload = {
      ...conversation,
      contactName: profileName,
      externalEntityName: profileName,
    };
    dispatch({ type: actionTypes.UPDATE_CALL_LOG, payload });
  } catch (err) {
    dispatch({ type: actionTypes.UPDATE_CALL_LOG_ERROR, payload: err });
  }
};

export const markCallNotificationViewed = () => async (dispatch) => {
  try {
    const {
      data: { message },
    } = await conversationService.post('/v1/markCallNotificationViewed');
    return message;
  } catch (err) {
    dispatch({ type: actionTypes.MARK_CALL_NOTIFICATION_ERROR, payload: err });
  }
};
